export default __webpack_public_path__ + "static/media/4523.2a20ef48.png";